<p-dialog [(visible)]="visible" appendTo="body" [modal]="!deviceManager.isMobile" [closable]="false" [showHeader]="true" styleClass="select-albums-dialog">
    <p-header>Select Albums</p-header>
    <div class="select-albums-dialog-content">
        <ng-container *ngIf="!busy; else loadingTpl">
            <p-listbox [options]="albums" [(ngModel)]="selectedAlbums" [multiple]="true" [checkbox]="true"
                       [listStyle]="{ maxHeight: 'none', overflow: 'auto' }"
                       optionLabel="Name" styleClass="albums-listbox" [filter]="true"
                       [filterPlaceHolder]="'Search albums'"
                       [emptyMessage]="'No albums found'">
                <ng-template let-album pTemplate="item">
                    <div class="album-row">
                        <span class="album-name">{{ album.Name }}</span>
                        <span class="album-meta" *ngIf="album.PhotosCount || album.VideosCount">
                        ({{ album.PhotosCount || 0 }} photos{{ album.VideosCount ? ', ' + album.VideosCount + ' videos' : '' }})
                    </span>
                        <span class="album-type" *ngIf="album.IsFolder">&nbsp;(has sub-albums)</span>
                    </div>
                </ng-template>
            </p-listbox>
        </ng-container>
        <ng-template #loadingTpl>
            <div class="loading-area">
                <p-progressSpinner strokeWidth="4"></p-progressSpinner>
            </div>
        </ng-template>
    </div>

    <ng-template pTemplate="footer">
        <button pButton type="button" class="ok-button" label="Use Selected Albums" icon="pi pi-check" (click)="onOk()"></button>
    </ng-template>
</p-dialog>
